
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","fill-rule":"evenodd","d":"M52 16a4 4 0 014 4v24a4 4 0 01-4 4H12a4 4 0 01-4-4V20a4 4 0 014-4h40zm0 2H12a2 2 0 00-1.987 1.767L10 20v24a2 2 0 001.767 1.987L12 46h40a2 2 0 001.987-1.767L54 44V20a2 2 0 00-1.767-1.987L52 18zm-14 2a4 4 0 014 4v16a4 4 0 01-4 4H16a4 4 0 01-4-4V24a4 4 0 014-4h22zm0 2H16a2 2 0 00-1.987 1.767L14 24v16a2 2 0 001.767 1.987L16 42h22a2 2 0 001.987-1.767L40 40V24a2 2 0 00-1.767-1.987L38 22zm7.5 17a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm5 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM25.014 26.226c.4.315.42.84.042 1.174-1.9 1.681-.829 3.535-.021 4.491.966 1.144 1.213 2.416.714 3.68-.487 1.233-1.617 2.22-2.212 2.386-.104.03-.211.043-.315.043-.418 0-.807-.22-.946-.568-.158-.395.059-.818.49-1.002.199-.132 1-.808 1.197-1.736.134-.638-.049-1.242-.56-1.847-1.94-2.296-1.864-4.758.2-6.586.378-.334 1.01-.35 1.41-.035zm6 0c.4.314.42.84.042 1.174-1.9 1.681-.829 3.535-.021 4.491.966 1.144 1.212 2.416.714 3.68-.488 1.233-1.617 2.22-2.212 2.386-.104.03-.211.043-.315.043-.418 0-.807-.22-.946-.568-.158-.395.059-.818.49-1.002.199-.132 1-.808 1.196-1.736.135-.638-.048-1.242-.559-1.847-1.94-2.296-1.864-4.758.2-6.586.378-.334 1.01-.35 1.41-.035zM45.5 34a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm5 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM48 22a4 4 0 110 8 4 4 0 010-8zm1.384 2.556l-2.667 2.979S47.512 28 48 28a2 2 0 002-2c0-.567-.616-1.444-.616-1.444z"}})])
          )
        }
      }
    